/**
 * EmptyState Component
 * Pure presentation component for empty state UI.
 */

import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  className = '',
}: EmptyStateProps) {
  const baseClasses = 'flex flex-col items-center justify-center py-[var(--space-12)] text-center';
  const classes = `${baseClasses} ${className}`.trim();

  return (
    <div className={classes}>
      {icon && <div className="mb-[var(--space-4)] text-[var(--surface-text-muted)]">{icon}</div>}
      <h3 className="text-[var(--text-lg)] font-semibold text-[var(--surface-text-primary)]">
        {title}
      </h3>
      {description && (
        <p className="mt-[var(--space-2)] text-[var(--text-base)] text-[var(--surface-text-secondary)] max-w-sm">
          {description}
        </p>
      )}
      {action && <div className="mt-[var(--space-6)]">{action}</div>}
    </div>
  );
}
